module.exports = __webpack_public_path__ + "img/Pelletsheizung.8ef94ce.webp";